import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './About.css';

const About = () => {
    const [aboutData, setAboutData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/about`);
                setAboutData(response.data);
                setLoading(false);
            } catch (error) {
                console.error('Error fetching about data:', error);
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    if (loading) return <div className="loading">Loading...</div>;
    if (!aboutData) return <div className="error">Failed to load about content</div>;

    return (
        <div className="about-container">
            <section className="about-hero">
                <h1>{aboutData.hero.title}</h1>
                <p>{aboutData.hero.subtitle}</p>
            </section>

            <section className="story-section">
                <h2>{aboutData.story.title}</h2>
                <p>{aboutData.story.content}</p>
            </section>

            <section className="mission-section">
                <h2>{aboutData.mission.title}</h2>
                <p>{aboutData.mission.content}</p>
            </section>

            <section className="values-section">
                <h2>Our Values</h2>
                <div className="values-grid">
                    {aboutData.values.map((value, index) => (
                        <div key={index} className="value-card">
                            <h3>{value.title}</h3>
                            <p>{value.description}</p>
                        </div>
                    ))}
                </div>
            </section>

            {/* <section className="team-section">
                <h2>Our Team</h2>
                <div className="team-grid">
                    {aboutData.team.map((member, index) => (
                        <div key={index} className="team-member-card">
                            <div className="member-info">
                                <h3>{member.name}</h3>
                                <h4>{member.role}</h4>
                                <p>{member.bio}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </section> */}
        </div>
    );
};

export default About; 